import { VendorRepository } from "../../repositories/VendorRepository";
import { VendorDetailResult } from "../../entities/VendorEntity";

/**
 * Get Vendor By ID Use Case
 * Retrieves a single vendor by their ID
 */
export class GetVendorByIdUseCase {
  constructor(private repository: VendorRepository) {}

  async execute(vendorId: string): Promise<VendorDetailResult> {
    // Validate vendor ID
    if (!vendorId || vendorId.trim() === "") {
      throw new Error("Vendor ID is required");
    }

    return await this.repository.getVendorById(vendorId);
  }
}

